export class BoardCertificationVM {
  id: any;
  name?: string;
  position?: number;
  runPublishingValidators?: boolean;
}